import { render, staticRenderFns } from "./colorTest.vue?vue&type=template&id=16798996&"
import script from "./colorTest.vue?vue&type=script&lang=js&"
export * from "./colorTest.vue?vue&type=script&lang=js&"
import style0 from "./colorTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports